import { gql } from '@grandvisionhq/graphql';

const address = gql`
  fragment AddressFragment on CartAddress {
    additionalStreetInfo
    apartment
    building
    city
    company
    countryCode
    department
    email
    externalId
    firstName
    key
    lastName
    mobile
    phone
    pOBox
    postalCode
    region
    salutation
    streetName
    streetNumber
    title
  }
`;

export { address };
//# sourceMappingURL=address.js.map
